import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import { CellEditor } from 'components/CellEditor';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { ExportPageData } from 'components/ExportPageData';
import { FilterTags } from 'components/FilterTags';
import { InputText } from 'primereact/inputtext';
import { Link } from 'react-router-dom';
import { PageRequestError } from 'components/PageRequestError';
import { Paginator } from 'primereact/paginator';
import { ProgressSpinner } from 'primereact/progressspinner';
import { SplitButton } from 'primereact/splitbutton';
import { Title } from 'components/Title';
import ClientiEditpPage from 'pages/clienti/Editp';
import useApi from 'hooks/useApi';
import useApp from 'hooks/useApp';
import useUtils from 'hooks/useUtils';

import useListPage from 'hooks/useListPage';
const ClientiListPage = (props) => {
		const app = useApp();
	const api = useApi();
	const utils = useUtils();
	const filterSchema = {
		search: {
			tagTitle: "Search",
			value: '',
			valueType: 'single',
			options: [],
		}
	}
	const pageController = useListPage(props, filterSchema);
	const filterController = pageController.filterController;
	const { records, pageReady, loading, selectedItems, apiUrl, sortBy, sortOrder, apiRequestError, setSelectedItems, getPageBreadCrumbs, onSort, deleteItem, pagination } = pageController;
	const { filters, setFilterValue } = filterController;
	const { totalRecords, totalPages, recordsPosition, firstRow, limit, onPageChange } =  pagination;
	function ActionButton(data){
		const items = [
		{
			label: "Edit",
			command: (event) => { app.navigate(`/clienti/edit/${data.id}`) },
			icon: "pi pi-pencil"
		},
		{
			label: "Delete",
			command: (event) => { deleteItem(data.id) },
			icon: "pi pi-trash"
		},
		{
			label: "View",
			command: (event) => { app.navigate(`/clienti/view/${data.id}`) }
		},
		{
			command: (event) => { app.openPageDialog(<ClientiEditpPage isSubPage apiPath={`/clienti/editp/${data.id}`} />, {closeBtn: true }) },
			icon: "pi pi-key"
		}
	]
		return (<SplitButton dropdownIcon="pi pi-bars" className="dropdown-only p-button-text p-button-plain" model={items} />);
	}
	async function onCellEditComplete(e) {
		const { rowData: data, newValue, field, originalEvent: event } = e;
		if (newValue){
			try{
				const payload = {
					[field]: newValue
				}
				data[field] = newValue;
				const url = `clienti/edit/${data.id}`;
				await api.post(url, payload);
			}
			catch(err){
				const msg = err?.request?.response || "Unabled to completed request";
				app.flashMsg("Update Field", msg, "error");
				console.error(err);
			}
		}
		else{
			event.preventDefault();
		}
	}
	function IdTemplate(data){
		if(data){
			return (
				<Link to={`/clienti/view/${data.id}`}> { data.id }</Link>
			);
		}
	}
	function RagioneSocialeTemplate(data){
		if(data){
			return (
				<span className="table-inlined-edit">{ data.ragione_sociale }</span>
			);
		}
	}
	function CittaTemplate(data){
		if(data){
			return (
				<span className="table-inlined-edit">{ data.citta }</span>
			);
		}
	}
	function TelefonoUfficioTemplate(data){
		if(data){
			return (
				<span className="table-inlined-edit">{ data.telefono_ufficio }</span>
			);
		}
	}
	function EmailTemplate(data){
		if(data){
			return (
					<a className="p-button-text" href={`mailto:${data.email}`}>{ data.email }</a>
			);
		}
	}
	function DirettoTemplate(data){
		if(data){
			return (
				<span className="table-inlined-edit">{ data.diretto }</span>
			);
		}
	}
	function PageLoading(){
		if(loading){
			return (
				<>
					<div className="flex align-items-center justify-content-center text-gray-500 p-3">
						<div><ProgressSpinner style={{width:'30px', height:'30px'}} /> </div>
						<div  className="font-bold text-lg">Caricamento in corso...</div>
					</div>
				</>
			);
		}
	}
	function EmptyRecordMessage(){
		if(pageReady && !records.length){
			return (
				<div className="text-lg mt-3 p-3 text-center text-400 font-bold">
					Nessun record trovato
				</div>
			);
		}
	}
	function MultiDelete() {
		if (selectedItems.length) {
			return (
				<div className="m-2 flex-grow-0">
					<Button onClick={() => deleteItem(selectedItems)} icon="pi pi-trash" className="p-button-danger" title="Elimina selezionato"/>
				</div>
			)
		}
	}
	function ExportData() {
		if (props.exportData && records.length) {
			const downloadFileName = `${utils.dateNow()}-clienti`;
			return (
				<div className="m-2">
					<ExportPageData pdf={false}  pageUrl={apiUrl} downloadFileName={downloadFileName} butonLabel="Esportare" tooltip="Esportare" buttonIcon="pi pi-print" />
				</div>
			);
		}
	}
	function PagerControl() {
		if (props.paginate && totalPages > 1) {
		const pagerReportTemplate = {
			layout: pagination.layout,
			CurrentPageReport: (options) => {
				return (
					<>
						<span className="text-sm text-gray-500 px-2">Record <b>{ recordsPosition } di { options.totalRecords }</b></span>
					</>
				);
			}
		}
		return (
			<div className="flex-grow-1">
				<Paginator first={firstRow} rows={limit} totalRecords={totalRecords}  onPageChange={onPageChange} template={pagerReportTemplate} />
			</div>
		)
		}
	}
	function PageActionButtons() {
		return (
			<div className="flex flex-wrap">
				<MultiDelete />
				<ExportData />
			</div>
		);
	}
	function PageFooter() {
		if (pageReady && props.showFooter) {
			return (
				<div className="flex flex-wrap">
					<PageActionButtons />
					<PagerControl />
				</div>
			);
		}
	}
	function PageBreadcrumbs(){
		if(props.showBreadcrumbs) {
			const items = getPageBreadCrumbs();
			return (items.length > 0 && <BreadCrumb className="mb-3" model={items} />);
		}
	}
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	return (
<main id="ClientiListPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container-fluid">
            <div className="grid justify-content-between align-items-center">
                <div className="col " >
                    <Title title="Clienti"   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
                <div className="col-fixed " >
                    <Link to={`/clienti/add`}>
                        <Button label="Aggiungere nuova" icon="pi pi-plus" type="button" className="p-button w-full bg-primary "  />
                        </Link>
                    </div>
                    <div className="col-12 md:col-3 " >
                        <span className="p-input-icon-left w-full">
                        <i className="pi pi-search" />
                        <InputText placeholder="Ricerca" className="w-full" value={filters.search.value}  onChange={(e) => setFilterValue('search', e.target.value)} />
                        </span>
                    </div>
                </div>
            </div>
        </section>
        }
        <section className="page-section " >
            <div className="container-fluid">
                <div className="grid ">
                    <div className="col comp-grid" >
                        <FilterTags filterController={filterController} />
                        <div >
                            <PageBreadcrumbs />
                            <div className="page-records">
                                <DataTable 
                                    lazy={true} 
                                    loading={loading} 
                                    editMode="cell" 
                                    selectionMode="checkbox" selection={selectedItems} onSelectionChange={e => setSelectedItems(e.value)}
                                    value={records} 
                                    dataKey="id" 
                                    sortField={sortBy} 
                                    sortOrder={sortOrder} 
                                    onSort={onSort}
                                    className="editable-cells-table p-datatable-sm" 
                                    stripedRows={true}
                                    showGridlines={false} 
                                    rowHover={true} 
                                    responsiveLayout="stack" 
                                    emptyMessage={<EmptyRecordMessage />} 
                                    >
                                    {/*PageComponentStart*/}
                                    <Column selectionMode="multiple" headerStyle={{width: '2rem'}}></Column>
                                    <Column  field="id" header="Id" body={IdTemplate}  ></Column>
                                    <Column  field="ragione_sociale" header="Ragione Sociale" body={RagioneSocialeTemplate}   onCellEditComplete={onCellEditComplete}  editor={(options) => <CellEditor options={options} type="text"   />}></Column>
                                    <Column  field="citta" header="Città" body={CittaTemplate}   onCellEditComplete={onCellEditComplete}  editor={(options) => <CellEditor options={options} type="text"   />}></Column>
                                    <Column  field="telefono_ufficio" header="Telefono Ufficio" body={TelefonoUfficioTemplate}   onCellEditComplete={onCellEditComplete}  editor={(options) => <CellEditor options={options} type="text"   />}></Column>
                                    <Column  field="email" header="Email" body={EmailTemplate}  ></Column>
                                    <Column  field="diretto" header="Diretto / Indiretto" body={DirettoTemplate}   onCellEditComplete={onCellEditComplete}  editor={(options) => <CellEditor options={options} type="select" dataSource={app.menus.diretto}  />}></Column>
                                    <Column  field="username" header="Username"   ></Column>
                                    <Column headerStyle={{width: '2rem'}} headerClass="text-center" body={ActionButton}></Column>
                                    {/*PageComponentEnd*/}
                                </DataTable>
                            </div>
                            <PageFooter />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
	);
}
ClientiListPage.defaultProps = {
	primaryKey: 'id',
	pageName: 'clienti',
	apiPath: 'clienti/index',
	routeName: 'clientilist',
	msgBeforeDelete: "Sei sicuro di voler cancellare questo record?",
	msgTitle: "Elimina record",
	msgAfterDelete: "Record cancellato con successo",
	showHeader: true,
	showFooter: true,
	paginate: true,
	isSubPage: false,
	showBreadcrumbs: true,
	exportData: true,
	importData: false,
	keepRecords: false,
	multiCheckbox: true,
	search: '',
	fieldName: null,
	fieldValue: null,
	sortField: '',
	sortDir: '',
	pageNo: 1,
	limit: 10,
}
export default ClientiListPage;
